import { gql } from '@apollo/client';

export const FUNNEL_FORM_OPTIONS_QUERY = gql`
  query GetFunnelFormOptions {
    vm {
      programs {
        programId
        name
        activities {
          activityId
          name
        }
      }
      activityRoles {
        activityRoleId
        name
      }
    }
  }
`;
